export const BASE_SITE_NAME = 'Le jardin de Jany';
export const CONTACT_MAIL = 'lejardindejany@gmail.com';
export const ADMIN_CONTACT_MAIL = 'morgan.denis.60@gmail.com';
export const PHONE_NUMBER = '+33698227720';
export const PRINTABLE_PHONE_NUMBER = '06 98 22 77 20';
